module.exports = __webpack_public_path__ + "static/media/metaData2.9e4fcefa.webp";